import { render, staticRenderFns } from "./bullsSemenProductionSummary.vue?vue&type=template&id=45d16ece&scoped=true&"
import script from "./bullsSemenProductionSummary.vue?vue&type=script&lang=js&"
export * from "./bullsSemenProductionSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d16ece",
  null
  
)

export default component.exports